// Sent to the person whose access was removed, not to the yard — a dispatcher
// removing a colleague is the one case where the account holder is not the one
// doing the removing, and emailDeleteHTML tells the other side of that story.
export function emailUserRemovedHTML(toEmail, toName, reloadYardName) {
  return `<!-- Begin HTML Content -->
        <h1> Transload Access Removed <br/></h1>
        <hr style="background:#2d8cff; height: 8px; width: 60px; border-style: solid; border-color: #095484; border-width: 1px 0 0 0; border-radius: 8px;" />
        <br><br>
        Hi ${toName}, <br/><br/>
        Your access to ${reloadYardName} on transloads.co has been removed by a
        dispatcher at your company. <br/>
        Any other transloads you work with are unaffected, and you can still sign
        in with this email address: <br/>
        ${toEmail} <br/>
        If you believe this was done by mistake, please contact your dispatcher.
        <br/><br/>
        <!-- End HTML Content -->`;
}
